import { faArrowAltFromLeft } from '@fortawesome/pro-light-svg-icons';
import { faArrowAltFromLeft as faArrowAltFromLeftSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContentType } from '@kcftech/prometheus-client';
import { ActionMenuItem } from 'components/menu/ActionMenuItem';
import { DirentMoveModal } from 'pages/Settings/FileLibrary/Folder/DirentMoveModal';
import { tokens } from 'styles/tokens';

import type { FileActionsBase } from './base';

function MoveMenuItem({ base }: { base: FileActionsBase }) {
    if (!base.canEditFileLibrary || base.fileType === ContentType.Invalid) {
        return null;
    }
    return (
        <ActionMenuItem
            title={base.fileType === ContentType.Folder ? 'Move Folder' : 'Move File'}
            hoverIcon={<FontAwesomeIcon icon={faArrowAltFromLeftSolid} />}
            icon={
                <FontAwesomeIcon
                    icon={faArrowAltFromLeft}
                    color={tokens.text.secondary}
                />
            }
            onSelect={() => base.openAction('move')}
        />
    );
}

function MoveModal({ base }: { base: FileActionsBase }) {
    return (
        <DirentMoveModal
            fileToBeMoved={base.rowData}
            onSave={() => {
                base.onChange();
                base.closeAction();
            }}
            onCancel={base.closeAction}
            locationId={base.locationId}
            corporationId={base.corporationId}
            foldersHierarchy={base.foldersHierarchy}
        />
    );
}

export const Move = {
    MenuItem: MoveMenuItem,
    Modal: MoveModal,
};
